import React, { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { StorageProductRelationProxy } from "@me-team/host/main/graphql/types";
import { useTranslation } from "react-i18next";

interface RenderWarehousesStockListProps {
    storageProductRelations: StorageProductRelationProxy[];
    currentBranchId: number;
}

const RenderWarehousesStockList: React.FC<RenderWarehousesStockListProps> = ({
    storageProductRelations,
    currentBranchId,
}) => {
    const { t } = useTranslation();
    const { currentBranchRelations, otherBranchRelations } = useMemo(() => {
        const safeRelations = storageProductRelations ?? [];

        const isCurrentBranch = (relation: StorageProductRelationProxy) => {
            const branchIdFromRelation = relation.storage?.branch?.id ?? null;
            return branchIdFromRelation === currentBranchId;
        };

        const current = safeRelations.filter(isCurrentBranch);
        const others = safeRelations.filter((relation) => !isCurrentBranch(relation));

        return { currentBranchRelations: current, otherBranchRelations: others };
    }, [storageProductRelations, currentBranchId]);

    if (!currentBranchRelations.length && !otherBranchRelations.length) {
        return null;
    }

    return (
        <Row className="gx-0">
            <Col className="text-start">
                {currentBranchRelations.length > 0 && (
                    <div className="mb-2">
                        <div className="mb-1">{t("This branch:")}</div>
                        <ul className="list-unstyled mb-0">
                            {currentBranchRelations.map((relation) => (
                                <li key={`current-${relation.id}`}>
                                    {relation.storage?.name} - {relation.quantityForRender}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {otherBranchRelations.length > 0 && (
                    <div>
                        <div className="mb-1">{t("Other branches:")}</div>
                        <ul className="list-unstyled mb-0">
                            {otherBranchRelations.map((relation) => (
                                <li key={`other-${relation.id}`}>
                                    {relation.storage?.name} - {relation.quantityForRender}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </Col>
        </Row>
    );
};

export default RenderWarehousesStockList;
